import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import type { IHsdqQuestion } from '../NewHsdqQuestionnaire';
import { hsdqQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step1(props: IQuestionnaireFormProps) {
    const questions: IHsdqQuestion[] = [
        {
            key: 'fatigueDuringTheDay',
            label: 'Ik heb overdag last van vermoeidheid',
            number: 1,
        },
        {
            key: 'annoyingItchy',
            label: 'Wanneer ik in bed ga liggen heb ik een vervelend kriebelig, brandend of jeukend gevoel in mijn benen',
            number: 2,
        },
        {
            key: 'dryMouth',
            label: 'Ik word ’s morgens met een droge mond wakker',
            number: 3,
        },
        {
            key: 'screaming',
            label: 'Ik word ’s nachts plotseling wakker, met een schreeuw en/of hevig transpirerend, en maak een angstige indruk',
            number: 4,
        },
        {
            key: 'difficultyWakingUp',
            label: 'Ik val pas tegen de ochtend in slaap en heb dan grote moeite om ’s morgens bijtijds wakker te worden. In het weekeinde slaap ik lang uit',
            number: 5,
        },
    ];

    return (
        <>
            <PageIntro
                subtitle={
                    'Weet je het antwoord op een vraag niet? Vraag het aan je partner, of vul in hoe je denkt dat het is.'
                }
                title="HSDQ: vragen deel 1/7"
            />

            <CustomContainer>
                {questions.map((question) => {
                    return (
                        <Stack key={question.key}>
                            <Step>{question.number}/32</Step>
                            <StyledFormGroup
                                hasErrors={props.errors.has(question.key)}
                                label={question.label}
                                layout="vertical"
                            >
                                <QuestionnaireRadioGroup
                                    {...props}
                                    customControlData={props.procedure.customControlData}
                                    customControlKey={question.key}
                                    questionnaireOptions={hsdqQuestionOptions}
                                />
                            </StyledFormGroup>
                        </Stack>
                    );
                })}

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
